import React, { useEffect, useState } from 'react'
import { OtpComponent, RunnerUpHeader} from '../../../ui'
import Button from '../../../library/components/Button'
import {useVerifyotpMutation} from '../../../services/ERO_management/otpservice'
import { parseJwt } from '../../utilities/utils'
import {useVerifyotpMutation as verifyOtpForNodal} from '../../../services/User_management/otpService'
import { ALERT_TYPE_SUCCESS , ALERT_TYPE_ERROR, BASE_URLS, PLATFORM_TYPE} from '../../../constants/constants'
import { createAlert } from '../../../features/alert/alerts'
import { useDispatch } from 'react-redux'
import axios from 'axios'
import RunnerUpHeaderNew from '../../../ui/runnerUpHeader/RunnerUpHeaderNew'

const VeriftOtp = ({onSuccess,nodalMobileNumber,userName}) => {
  const officerId = parseJwt(localStorage?.access_token)?.preferred_username
  const mobileNo = parseJwt(localStorage?.access_token)?.phone_number

  const [otp, setOtp] = useState('')
  const [popUpMobNo,setPopMobileNumber]=useState()
  const [verifyOtpModalMessage,setVerifyOtpModalMessage]=useState("Update the User.")

  const [verifyOtp, verifyOtpRes] = useVerifyotpMutation()
  const [NodalverifyOtp, nodalVerifyOtpRes] = verifyOtpForNodal()
  const dispatch = useDispatch()
 
useEffect(()=>{
  if(localStorage.userrole==="eci" || localStorage.userrole==="ceo" || localStorage.userrole==="ceoa" || localStorage.userrole==="ero")
  {
    setPopMobileNumber(mobileNo)
  }
  else
  {
    setPopMobileNumber(nodalMobileNumber)
  }
},[])

useEffect(()=>{
  if(localStorage.userrole==="ero")
  {
   setVerifyOtpModalMessage("Finalize.")
  }
},[])

  useEffect(() => {
    if (verifyOtpRes.isSuccess) {
      onSuccess();
    }
  },[verifyOtpRes.isSuccess])

  useEffect(() => {
    if (nodalVerifyOtpRes.isSuccess) {
      onSuccess();
    }
  },[nodalVerifyOtpRes.isSuccess])

  const verifyOTP = () => {
    if(localStorage.userrole==="eci" || localStorage.userrole==="ceo" || localStorage.userrole==="ceoa" || localStorage.userrole==="ero")
    {
    //   verifyOtp({
    //     userName: userName,
    //     userCreation: false,
    //     otp: otp,
    //   }).unwrap()
    // .then((res)=>{
    // }).catch((error)=>{
    //     onReject(error?.data?.message)
    // })
    axios
    .post(
      BASE_URLS.USERMANAGEMENT_BASE_URL +
        `api/v1/user-management/otp/verify`,
        {
              userName: userName,
              userCreation: false,
              otp: otp,
            },
      {
        headers: {
          applicationName: "ERONET",
          "atkn_bnd": localStorage?.atkn_bnd,
          "rtkn_bnd": localStorage?.rtkn_bnd,
          "channelidobo": "ETPBMS",
          "PLATFORM-TYPE":PLATFORM_TYPE
        },
      }
    )
    .then(
      (response) => {
        console.log(response)
        if (response?.data) {
          const obj = parseJwt(response?.data);
          onSuccess(obj.isVerified)
        } else if (response?.response?.data) {
        }
      },
    ).catch((err)=>{
     if(err?.response?.data){
      const obj = parseJwt(err?.response?.data);
      onReject(obj.message)
     }
    })
    }
    else
    {
      NodalverifyOtp({
        otp:otp,
        userId: officerId
      })
    }
  }

    const onReject = (msg) => {
    dispatch(
      createAlert({
        message: msg,
        type: ALERT_TYPE_ERROR,
        heading: "Reject",
      })
    );
  };

  return (
    <div className="container box">
      <div className="generate-epb col-md-12">
          <>
            <RunnerUpHeaderNew title={'Verify OTP to proceed'} />
            <p>
              Please enter the OTP received on your Mobile number +91 - {popUpMobNo}{`${' '}`}
              to {verifyOtpModalMessage}
            </p>
            <OtpComponent setOtp={setOtp} otp={otp} />
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                margin: '15px',
              }}
            >
              <Button
                btnClass="verify-btn"
                value="Verify otp"
                disabled={otp.length < 6 || verifyOtpRes.isSuccess}
                onClick={verifyOTP}
              />
            </div>
          </>
      </div>
    </div>
  )
}
export default VeriftOtp;
